import { useTranslation } from "react-i18next";
import Style from "./KeyServiceCard.module.scss";

const KeyServiceCard = ({ title, icon, link }) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className={Style.service_card}>
      <div className={Style.service_icon}>
        <img src={icon} alt={title} />
      </div>
      <h3 className={Style.service_title}>{title}</h3>
      <a
        href={link}
        target='_blank'
        className={`btn btn-primary ${Style.service_btn}`}
      >
        <span>{t("keyFactsStatement")}</span>
      </a>
    </div>
  );
};

export default KeyServiceCard;
